import React, { useState } from "react";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import Switch from "react-switch";
import { NavLink } from "react-router-dom";
// import SuperAdminOfferDelete from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminOfferDelete";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { REFERRAL_TYPE } from "./../../../../enums/OrderEnums";
import SuperAdminDeleteReferral from "./SuperAdminDeleteReferral";

const ViewReferralDetails = ({
  onClickshowView,
  onClickCloseView,
  data,
}) => {
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);

  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  return (
    <>
      <Modal
        show={onClickshowView}
        onHide={onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Referral Program</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="enGrayBorderBox">
            <Row className="px-4">
                <Row className="w-100">
                  <Col lg={6} md={6} className="py-3">
                    <div className="f12-500 pb-3 opacity5">Referral Program Name*</div>
                    <div className="f14-500 pb-3">{REFERRAL_TYPE[data?.referral_type]} Referral</div>
                  </Col>
                  <Col lg={6} md={6} className="py-3 d-flex justify-content-end">
                  <SuperAdminDeleteReferral refId={data?._id} />
                    <NavLink
                    className="enIconBtn mr-3"
                    to={`/SuperAdminReferralRewarddashboard/edit-referral-reward-request/${data?._id}`}
                    >
                            <Image
                                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit req"
                                title="Edit referral"
                                fluid
                            />
                    </NavLink>
                  </Col> 
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3 opacity5">Description</div>
                    <div className="f14-500 pb-3">{data?.description} </div>
                  </Col>
                </Row>
            </Row>
          </div>
          <hr />
          <Row>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(data && data.start_date).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">Start Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(data && data.start_date).format("LT")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3 border-right">
              <div className="pb-2 f12-400 opacity5">End Date</div>
              <div className="d-flex align-items-center">
                <Image
                  src={require("../../../../assets/images/UserManagement/calendar.svg")}
                  alt="View"
                  title="View"
                  width="20px"
                  className="mr-2"
                />
                <div className="f16-700">
                  {" "}
                  {moment(data && data.end_date).format("DD/MM/YYYY")}
                </div>
              </div>
            </Col>
            <Col lg={3} md={6} className="my-3">
              <div className="pb-2 f12-400 opacity5">End Time</div>
              <div className="d-flex align-items-center">
                <div className="f16-700">
                  {" "}
                  {moment(data && data.end_date).format("LT")}
                </div>
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="w-100">
                  <Col lg={9} md={6} className="py-3">
                    <div className="f12-500 pb-3 opacity5">Referral Activity Type</div>
                    <div className="f14-500 pb-3">{"With Registration Activity"}</div>
                      
                  </Col>
                  <Col lg={3} md={6} className="py-3  justify-content-end">
                  <div className="f12-500 pb-3 opacity5">Referral Amount Details</div>
                    <div className="f14-500 pb-3"> {" "}
                    Referrer: ₹ {data?.referrer_amount} <br />
                    Referee: ₹{data?.referee_amount} <br />
                    Udbhav: ₹{data?.udbhav_amount}</div>
                  </Col>
                </Row>
                <hr />
                <Row>
                    <Col lg={8}>
                    <div className="f12-500 pb-3 opacity5">Terms and Conditions</div>
                    <div className="f14-500 pb-3">{data?.term_and_condition}</div>
                    </Col>
                </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

ViewReferralDetails.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(ViewReferralDetails);
